module.exports = ".content {\n  flex: 1;\n  width: 85vw;\n}\n\nmain {\n  margin: 2.5rem 10rem 15rem 7.5rem;\n}\n"